import React from 'react';
import guid from '../../util/guid';
import { findDOMNode } from 'react-dom';

const groupBy = (array, field) => {
  let id;
  const result = Object.create(null);

  if (typeof field === 'string') {
    for (const item of array) {
      id = String(item[field]);

      if (!result[id]) {
        result[id] = [item];
      } else {
        result[id].push(item);
      }
    }
  } else if (typeof field === 'function') {
    for (const item of array) {
      id = String(field(item));

      if (!result[id]) {
        result[id] = [item];
      } else {
        result[id].push(item);
      }
    }
  }

  return result;
};

const getBestWidth = ({ headerWidth, bodyWidths }) => {
  const sizeGroup = groupBy(bodyWidths, (size) => {
    const groupIndex = (size / 10).toFixed();
    return groupIndex;
  });

  const values = Object.values(sizeGroup).sort(
    (sizesA, sizesB) => sizesB.length - sizesA.length
  )[0];
  // const value = values.reduce( ( pv, cv, i ) => ( ( pv * i + cv ) / ( i + 1 ) ), 0 );
  const value = Math.max.apply(null, values);

  return Math.max(headerWidth, value);
};

export default class AutoWidth {
  padding = 15;

  enable = true;

  columns = Object.create(null);

  Calculators = Object.create(null);

  colGroups = [];

  constructor({ padding = null, table } = {}) {
    if (typeof padding === 'number') {
      this.padding = padding;
    }

    this.table = table;
  }

  init() {
    this.columns = Object.create(null);
    this.Calculators = Object.create(null);
    this.colGroups.length = 0;
  }

  analyzeColDefine(column) {
    if (column && column.width === 'auto') {
      this.columns[column.columnId] = {
        calced: false,
        headerCalculator: null,
        headerWidth: null,
        bodyCalculators: [],
        bodyWidths: [],
        bestWidth: null,
        isMax: false,
      };
    }
  }

  bindColGroup(colGroup) {
    if (!this.enable) {
      return;
    }

    const { colGroups } = this;

    if (!colGroups.includes(colGroup)) {
      colGroups.push(colGroup);
    }
  }

  bindCalculator(id, target) {
    this.Calculators[id] = target;
  }

  renderCalculator(columnId, isInHeader, content, children) {
    if (!this.enable) {
      return null;
    }

    const column = this.columns[columnId];

    if (column) {
      const calculatorId = guid('aw-');

      if (isInHeader) {
        column.headerCalculator = calculatorId;
      } else {
        column.bodyCalculators.push(calculatorId);
      }

      return (
        <Calculator id={calculatorId} AutoWidthInstance={this}>
          {content}
          {children}
        </Calculator>
      );
    } else {
      return null;
    }
  }

  calcAndUpdate() {
    const { colGroups, columns } = this;
    const columnIds = Object.keys(columns);
    let maxValue = 0;
    let maxValueId = null;

    for (const id of columnIds) {
      const column = columns[id];
      const { headerCalculator, bodyCalculators } = column;

      if (headerCalculator) {
        column.headerWidth = this.Calculators[headerCalculator].getWidth();
      }

      if (bodyCalculators.length) {
        column.bodyWidths = bodyCalculators.map((i) => this.Calculators[i].getWidth());
      }

      if (column.bodyWidths.length) {
        column.bestWidth = getBestWidth(column);

        if (column.bestWidth > maxValue) {
          maxValue = column.bestWidth;
          maxValueId = id;
        }
      }
    }

    if (maxValueId) {
      const column = columns[maxValueId];
      column.bestWidth = null;
    }

    for (const colGroup of colGroups) {
      colGroup.forceUpdate();
    }
  }

  getBestWidth(columnId) {
    const column = this.columns[columnId];

    if (column && column.bestWidth) {
      return column.bestWidth + this.padding * 2;
    } else {
      return null;
    }
  }
}

class Calculator extends React.Component {
  constructor(props) {
    super(props);
    const { AutoWidthInstance, id } = this.props;
    AutoWidthInstance.bindCalculator(id, this);
  }

  componentDidUpdate() {
    const { AutoWidthInstance, id } = this.props;
    AutoWidthInstance.bindCalculator(id, this);

    const container = findDOMNode(this);
    container.style.display = 'block';
  }

  getWidth() {
    const container = findDOMNode(this);
    const content = container.querySelector('.auto-width-calculator-content');
    const { width } = content.getBoundingClientRect();
    container.style.display = 'none';
    return width;
  }

  render() {
    const { content, children } = this.props;

    return (
      <div style={{ cssText: 'position: relative; opacity: 0; pointer-events: none' }}>
        <div style={{ cssText: 'position: absolute; width: 2000px' }}>
          <div className="auto-width-calculator-content" style={{ cssText: 'position: absolute' }}>
            {content}
            {children}
          </div>
        </div>
      </div>
    );
  }
}
